import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type InkleAISliderState = {
  prefilledMessage: string | null;
};

const initialState: InkleAISliderState = {
  prefilledMessage: null,
};

export const inkleAISlider = createSlice({
  name: "inkleAISlider",
  initialState,
  reducers: {
    openInkleAIWithMessage: (
      state,
      action: PayloadAction<{ message: string }>
    ) => {
      state.prefilledMessage = action.payload.message;
    },
    clearInkleAIMessage: (state) => {
      state.prefilledMessage = null;
    },
  },
});

export const { openInkleAIWithMessage, clearInkleAIMessage } =
  inkleAISlider.actions;
export default inkleAISlider.reducer;
